/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { Icon } from '@iconify/react';
import { Box, ThemeProvider, createMuiTheme } from '@material-ui/core';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import mdClose from '@iconify/icons-ion/md-close';
import moment from 'utils/moment';
import { getFeeWithInvoice } from '../../../components/ActionCompo';
import Detail from '../../../../../components/DetailPageBuilder/Detail';
import { changeCurrentPage } from '../../../../../general_redux/actions';
import Modal from '../../../../../components/modal';
import { clearDraftState, fetchspecificAvpLogs, getAvpCategories, getAvpDefaultFields, getAvpFeeMatrix,
   get_AVP_comments } from '../../../redux/action';
import styles from '../../../../../components/DetailPageBuilder/detail.module.scss';
import { getApiBaseUrl } from '../../../../../constants/apiEnv';
import Loading from '../../../../../components/loading/loading';
import { renderInfoForType, showCustomTable } from '../../../../../utils/helpers';

const DEFAULT_IDS = [
  'first_name', 'last_name', 'phone', 'email', 'company_address', 'category_of_avp', 'purpose_of_vehicle',
  'category_of_veh_equp', 'signature', 'vrea', 'location_of_parking', 'tpaa',
  'type_of_veh_equp', 'tpao', 'reg_no_veh_eqpt', 'pc_validity', 'type_of_issue',
  'employee_id', 'make_type', 'veh_powered_by', 'veh_insurance_company',
  'designation', 'insurance_validity', 'year_of_reg', 'length', 'width', 'height'
];

const defectsStatus = {
  pending_review: { title: 'Pending Review', color: '#3c62a8' },
  rejected: { title: 'Rejected', color: 'rgb(255, 87, 51)' },
  open: { title: 'Open', color: '#404040' },
  closed: { title: 'Closed', color: 'rgb(113,215,88)' }
};

const AvpDetailPage = (props) => {
  const dispatch = useDispatch();

  const baseURL = getApiBaseUrl() || 'https://api.us.aerosimple.com/api';
  const jwtToken = localStorage.getItem('token');

  const profile = useSelector(s => s?.auth?.profile);
  const log = useSelector(s => s?.permitManagement?.avpSpecificLog);
  const settings = useSelector(s => s?.permitManagement?.avpSettings);
  const avpGetSchemaSettings = useSelector(s => s?.permitManagement?.avpGetSchemaSettings);
  const loadingStatus = useSelector(s => s?.permitManagement?.loader);
  const avp_defaultFields = useSelector(s => s?.permitManagement?.avpDSchema);
  const avp_customFields = useSelector(s => s?.permitManagement?.avpCSchema);
  const avpCategories = useSelector(states => states?.permitManagement?.avpCategoryList);
  const avpPaymentStatus = useSelector(state => state?.permitManagement?.getAvpPaymentAction);
  const avp_order = useSelector(s => s?.permitManagement?.avpOrder);
  const feeTypesList = useSelector(states => states?.permitManagement?.avpFeeMatrix);
  const comments = useSelector(states => states?.permitManagement?.comments);

  const logId = props?.match?.params?.id;
  const isDefectEnabled = profile?.portal_airport?.airport_settings?.enable_vehicle_defects;

  const [historyModal, setHistoryModal] = useState(false);
  const [violationsHistory, setViolationsHistory] = useState([]);
  const [defectsHistory, setDefectsHistory] = useState([]);
  const [loader, setLoader] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [isRejected, setIsRejected] = useState(false);

    const Theme = useMemo(() => createMuiTheme({
      overrides: {
        MuiTimeline: {
          root: {
            padding: 0
          }
        },

        MuiTimelineItem: {
          missingOppositeContent: {
            '&:before': {
              display: 'none'
            }
          }
        },

        MuiTimelineDot: {
          defaultPrimary: {
            backgroundColor: '#A6E50F',
            margin: 0
          },
          defaultSecondary: {
            backgroundColor: '#3A61A8',
            margin: 0
          }
        },

        MuiTimelineConnector: {
          root: {
            width: '1px',
            background: '#DBE4F0 0% 0% no-repeat padding-box',
            backgroundColor: '#DBE4F0',
            opacity: 1
          }
        },

        MuiTimelineContent: {
          root: {
            padding: '6px 10px'
          }
        }
      }
    }), []);

  const headers = useMemo(() => ({
    'Content-Type': 'application/json',
    Authorization: jwtToken
  }), [jwtToken]);

  const handleShowFieldLabel = () => (log?.settings?.skip_avp_badge_number_selection ? 'System generated' : profile.permit_management?.badge);

  const TodayDate = useMemo(() => moment(), []);

  const tableHeaders = useMemo(() => [
    ['comment', 'Comment'],
    ['created_at', 'Applied On'],
    ['type_of_issue', 'Application Type'],
    ['first_name', 'First Name'],
    ['last_name', 'Last Name'],
    ['phone', 'Phone'],
    ['email', "Applicant's Email"],
    ['company_address', 'Company Address'],
    ['employee_id', 'Employee ID'],
    ['company', 'Company'],
    ['designation', 'Designation'],
    ['avp_validity', `${profile.permit_management?.renewal || 'Renewal'} Date`],
    ['year_of_reg', 'Year Of Registration'],
    ['length', 'Length'],
    ['height', 'Height'],
    ['width', 'Width'],
    ['purpose_of_vehicle', 'Purpose Of Vehicle'],
    ['category_of_avp', 'Category Of Avp'],
    ['category_of_veh_equp', 'Category of Vehicle/Equipment'],
    ['type_of_veh_equp', 'Type of Vehicle/Equipment'],
    ['vrea', 'Vehicle Recovery Equipment Availability'],
    ['location_of_parking', 'Location of Designated Parking on Airside'],
    ['tpaa', 'Total Parking Area Allocated (sq. mt)'],
    ['tpao', 'Total Parking Area Occupied (sq. mt)'],
    ['reg_no_veh_eqpt', 'Registration Number of Vehicle/Equipment '],
    ['veh_insurance_company', 'Vehicle Insurance Company'],
    ['insurance_validity', 'Validity of Insurance'],
    ['pc_validity', 'Validity of Pollution Certificate'],
    ['veh_powered_by', 'Vehicle Powered By'],
    ['make_type', 'Make Type']
  ], [profile]);

  const firstHeaders = useMemo(() => [
    ['comment', 'Comment'],
    ['type_of_issue', 'Application Type'],
    ['company', 'Company'],
    ['created_at', 'Applied On'],
    ['avp_no', `${handleShowFieldLabel() || 'Badge'} Number`],
    ['avp_validity', `${profile.permit_management?.renewal || 'Renewal'} Date`]
  ], [profile, log]);

  const lastHeaders = useMemo(() => {
    const fIds = avp_defaultFields?.map(f => f.id);
    const hasLWH = ['length', 'width', 'height'].every(fId => fIds?.includes(fId));
    const base = [
      ['submitted_by', 'Initiated By']
    ];
      if (!hasLWH) {
        base.push(['length', 'Length']);
        base.push(['height', 'Height']);
        base.push(['width', 'Width']);
      }

      if (log?.settings?.enable_quantum_points_avp) {
      base.push(['quantum_points', 'Quantum Points']);
    }
    return base;
  }, [log, avp_defaultFields]);

  const allAvpFields = useMemo(() => {
    if (!avp_defaultFields?.length) return [];

    const merged = [...avp_defaultFields, ...avp_customFields];

    merged.forEach((item) => {
      if (DEFAULT_IDS.includes(item.id) && item.type === 'select') {
        if (item.values?.length > 0) {
          item.values.forEach((val) => {
            if (val.key.toString() !== val.value.toString()) {
              val.key = val.value;
            }
          });
        }
        if (item.conditional_values?.length > 0) {
          item.conditional_values.forEach((val) => {
            if (val.label.toString() !== val.value.toString()) {
              val.label = val.value;
            }
          });
        }
      }
    });

    return merged;
  }, [avp_defaultFields, avp_customFields]);

  useEffect(() => {
    setIsRejected(
      Object.keys(log?.attachments_info || {})?.includes('rejected_documents')
      && Object.keys(log?.attachments_info?.rejected_documents || {})?.length > 0
    );
  }, [log?.attachments_info]);

  const handleComments = () => {
    setCommentModal(true);
  };

  const getLatestAvpDetails = useCallback(() => {
    dispatch(fetchspecificAvpLogs(logId));
  }, [dispatch, logId]);

  const handleDefectsHistory = useCallback(() => {
    setLoader(true);
    Axios.get(`${baseURL}/app/defects/vehicle_permit/${logId}/defects_history`, { headers })
      .then(res => setDefectsHistory(res.data || []))
      .catch(() => toast.error('Please try again later'))
      .finally(() => setLoader(false));
    setHistoryModal(true);
  }, [baseURL, headers, logId]);

  const handleViolationsHistory = useCallback(() => {
    setLoader(true);
    Axios.get(`${baseURL}/app/violations/vehicle_permit/${logId}/violations_history`, { headers })
      .then(res => setViolationsHistory(res.data || []))
      .catch(() => toast.error('Please try again later'))
      .finally(() => setLoader(false));
    setHistoryModal(true);
  }, [baseURL, headers, logId]);

  const selectedCategory = avpCategories?.find(c => ((c.name === log?.category_of_avp) && (c.id === log?.avp_category)));

  const rePrintList = (feeTypesList?.filter(item => (
    item?.category?.name?.toLowerCase() === selectedCategory?.name?.toLowerCase()
      && item?.name === 'on_reprint_application'
    ))
    .map(item => ({ name: item?.fee_name, id: item?.id })) || []);

  useEffect(() => {
    if (avpPaymentStatus?.success) {
      dispatch(fetchspecificAvpLogs(logId));
    }
  }, [avpPaymentStatus, getLatestAvpDetails, dispatch]);

  useEffect(() => {
    dispatch(get_AVP_comments(logId, true));
  }, [logId]);

  useEffect(() => {
    dispatch(fetchspecificAvpLogs(logId));
    dispatch(getAvpCategories());
  }, [dispatch, logId]);

  useEffect(() => {
    dispatch(getAvpFeeMatrix(log?.tenant));
    dispatch(getAvpDefaultFields());
  }, [log?.tenant]);

  useEffect(() => {
    dispatch(changeCurrentPage(profile?.permit_management?.vehicle_permit || 'AVP'));
  }, []);

  const getDescription = () => {
    const applicationFeeTypes = settings?.application_based_fee_types || [];
    const currentFeeType = applicationFeeTypes.find(feeType => feeType.key === log?.payment_stage);
    return currentFeeType?.name || '';
  };
  const invoiceObject = getFeeWithInvoice({
    description: getDescription(),
    feeCategoryData: feeTypesList,
    taxData: avpGetSchemaSettings?.tax_details || [],
    applicationType: log?.type_of_issue,
    applicationFor: log?.payment_stage || (log?.status !== 3 && 'on_application_submission'),
    selectedCategory: log?.category_of_avp,
    isVatApplicable: log?.meta_data?.isVatApplicableForAvp,
    feeCategory: log?.vehicle_info?.reprint_info?.feeDetails || null
  }) || {};
  const buildInvoiceData = (payment, currencyType) => ({
    invoiceColumns: [
      { label: 'Description', key: 'feeCategoryName' },
      { label: 'Quantity', key: 'quantity' },
      { label: 'Unit Price (excl. VAT)', key: 'baseFeeWithoutTax' },
      { label: 'VAT Percentage', key: 'taxRate' },
      { label: 'Amount (incl. VAT)', key: 'totalFeeWithTax' }
    ],
    columnData: payment?.other_info?.invoiceObject?.map(eachObj => ({
      ...eachObj,
      quantity: 1,
      baseFeeWithoutTax: `${currencyType} ${Number(eachObj?.baseFeeWithoutTax)?.toFixed(2)}`,
      taxRate: eachObj?.taxAmount ? `${Number(eachObj?.taxRate)?.toFixed(2)} %` : '0.00 %',
      totalFeeWithTax: `${currencyType} ${Number(eachObj?.totalFeeWithTax)?.toFixed(2)}`
    })) || [],
    tblRow: { fontSize: '20px' },
    tblData: { fontSize: '20px' }
  });

  // attach invoice details for each payment
  if (log?.settings?.custom_invoice_template) {
    log.showCustomTable = showCustomTable;

    const fullAddress = Array.isArray(log?.company_address)
      && log?.company_address?.map(a => [a.street, a.city, a.state, a.zip]
      .filter(Boolean).join(', ')).join(' | ');

    log.invoicesByFeeType = log?.work_flow?.payments?.map(payment => ({
      ...payment,
      invoiceData: buildInvoiceData(payment, payment?.other_info?.currency),
      invoiceDate: renderInfoForType({ type: 'datetime' }, payment?.payment_date),
      companyAddress: fullAddress
    }));
  }
  useEffect(() => () => dispatch(clearDraftState()), [dispatch]);

  const hasOfflinePayment = avpGetSchemaSettings?.avp_payment_type_for_tenant === 'offline';

  return (
    <>
      <Loading loadingStatus={loadingStatus} />

      {log && (
        <Detail
          backRoute="/avp/logs"
          logData={log}
          firstHeaders={firstHeaders}
          lastHeaders={lastHeaders}
          tableHeaders={tableHeaders}
          panelname={profile?.permit_management?.vehicle_permit || 'AVP'}
          {...props}
          actionsBtn
          actionPending
          handelHistory={isDefectEnabled ? handleDefectsHistory : handleViolationsHistory}
          adpHistory={
            isDefectEnabled
              ? `${profile?.permit_management?.vehicle_defect || 'Defects'} History`
              : `${profile?.permit_management?.violations || 'Violations'} History`
          }
          avpDetailsPage
          adpComments={`${profile?.permit_management?.comments || 'Comments'}`}
          handleComments={handleComments}
          isRejected={isRejected}
          getLatestAvpDetails={getLatestAvpDetails}
          paymentByTenant={log?.meta_data?.charge_fees_per_avp_permit}
          hasOfflinePayment={hasOfflinePayment}
          invoiceObject={invoiceObject}
          defaultIDs={DEFAULT_IDS}
          allFields={allAvpFields}
          rePrintList={rePrintList}
          category={log?.category_of_avp}
          order={avp_order}
          settings={settings}
          logId={logId}
        />
      )}

      <Modal
        showIn={commentModal}
        onClose={() => setCommentModal(false)}
        closeIcon disableOutsideClick
        width="864px" minHeight="150px"
        title="Rejected Documents"
        btnList={[
          { id: 'close', label: 'Close', action: 'tertiary', onClick: () => setCommentModal(false) }
        ]}
      >
        <div className={styles.timelineContainer}>
          <ThemeProvider theme={Theme}>
            {Object.values(comments?.audit_logs || {})?.map(each => (
              <Timeline key={each.document_name}>
                <TimelineItem align="left">
                  <TimelineSeparator>
                    <TimelineDot color={'primary'} />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <div
                      className={styles.timelineItemContent}
                    >
                      <p className={styles.commentValue}>
                        {each?.description === 'Application rejected'
                        ? (
                         <>
                          <b>Application Status: </b>
                          <span>Rejected</span>
                         </>
                        )
                        : (
                         <>
                          <b>Document Name: </b>
                          <span>{each?.description?.split(' ').slice(2, -1).join(' ') || '-'}</span>
                         </>
                        )}
                      </p>
                      <p className={styles.commentValue}>
                        <b>Rejected On: </b>
                        <span>
                          {renderInfoForType({ 'type': 'datetime' }, each?.date, null, null)}
                        </span>
                      </p>
                      <p className={styles.commentTitle}>
                        <b>Comment: </b>
                        <span>{each?.description === 'Application rejected'
                          ? each?.meta_data?.reason : each?.meta_data?.reason?.split(':')[1] || '-'}
                        </span>
                      </p>
                    </div>
                  </TimelineContent>
                </TimelineItem>
              </Timeline>
            ))}
          </ThemeProvider>
        </div>
      </Modal>

      <Modal
        onClose={() => setHistoryModal(false)}
        showIn={historyModal}
        width="864px"
        minHeight="70%"
      >
        <Loading loadingStatus={loader} />

        <Box className={styles.headerBox}>
          <div className={styles.commentsHeader}>
            <div className={styles.title}>
              <FormattedMessage
                id=" "
                defaultMessage={isDefectEnabled
                  ?`${props.profile?.permit_management?.vehicle_defect || 'Defects'} History`
                  :`${profile?.permit_management?.violations || 'Violations'} History`}
                values={{ id: 27 }}
              />
            </div>
          </div>
          <Icon icon={mdClose} height="20" onClick={() => setHistoryModal(false)} style={{ cursor: 'pointer' }} />
        </Box>

        {/* HISTORY TABLE */}
        <div className={styles.history}>
                    {(!isDefectEnabled && violationsHistory && violationsHistory?.length > 0)
            && <table style={{ width: '100%' }}>
                <thead>
                  <tr className={styles.table_heading}>
                    <th style={{ minWidth: '13%' }}>{profile.permit_management?.badge || 'Badge'} Number</th>
                    <th style={{ minWidth: '12%', marginRight: '15px' }}>Type</th>
                    <th style={{ minWidth: '10%', marginRight: '20px' }}>Offence</th>
                    <th style={{ minWidth: '14%', marginRight: '5px' }}>Description</th>
                    <th style={{ minWidth: '10%' }}>{profile?.permit_management?.violations || 'Violation'} Date</th>
                    <th style={{ minWidth: '8%' }}>Points</th>
                    <th style={{ minWidth: '10%' }}>Expiry Date</th>
                    <th style={{ minWidth: '12%' }}>Warning/Penalty</th>
                    <th style={{ minWidth: '10%' }}>Status</th>
                  </tr>
                  <hr />
                </thead>
                <tbody>
                {violationsHistory.map(item => (
                  <><tr className={styles.table_data}>
                    <td style={{ minWidth: '13%' }}>{item?.permit_no
                      || item?.permit_management_vehiclepermit?.avp_no || item?.permit_management_vehiclepermit?.vehicleInfo?.prev_avp_no
                      || item?.permit_management_vehiclepermit?.vehicleInfo?.avp_no}
                    </td>
                    <td style={{ minWidth: '12%', marginRight: '15px' }}>{item?.type}</td>
                    <td style={{ minWidth: '10%', marginRight: '20px' }}>{item?.sub_type || ''}</td>
                    <td style={{ minWidth: '14%', marginRight: '5px' }}>{item?.violation_details}</td>
                    <td style={{ minWidth: '10%' }}>{moment(item?.violation_at).format(localStorage?.getItem('dateFormat') || 'MM/DD/YYYY')}</td>
                    <td style={{ minWidth: '8%' }}>{item?.points}</td>
                    <td style={{ minWidth: '10%' }}>
                      {item?.valid_until && moment(item?.valid_until).format(localStorage?.getItem('dateFormat') || 'MM/DD/YYYY')}
                    </td>
                    <td style={{ minWidth: '12%' }}>{item.warning_only? 'Warning': 'Penalty'}</td>
                    <td style={{ minWidth: '10%' }}>{TodayDate >= moment(item?.valid_until)
                      ? <div style={{ color: 'grey' }}> Inactive</div>
                      : <div style={{ color: '#3A61A8' }}>Active</div>}
                    </td>
                    </tr>
                    <hr />
                  </>
                  ))}
                </tbody>
               </table>
            }
            {(isDefectEnabled && defectsHistory && defectsHistory?.length > 0) && (
              <table style={{ width: '100%' }}>
                <thead>
                  <tr className={styles.table_heading}>
                    <th style={{ width: '15%' }}>{profile?.permit_management?.vehicle_defect || 'Defect'} Date</th>
                    <th style={{ width: '15%' }}>Registration No</th>
                    <th style={{ minWidth: '13%' }}>{profile.permit_management?.badge || 'Badge'} Number</th>
                    <th style={{ width: '15%' }}>Category</th>
                    <th style={{ width: '12%', marginRight: '90px' }}>Sub Category</th>
                    <th style={{ width: '20%' }}>Description</th>
                    <th style={{ width: '10%' }}>Status</th>
                  </tr>
                  <hr />
                </thead>
                <tbody>
                {defectsHistory.map(item => (
                  <>
                    <tr className={styles.table_data} style={{ wordBreak: 'break-all' }}>
                      <td style={{ width: '15%' }}>{moment(item?.created_at).format(localStorage?.getItem('dateFormat') || 'MM/DD/YYYY')}</td>
                      <td style={{ width: '15%' }}>{item?.veh_reg_no}</td>
                      <td style={{ width: '15%' }}>{item?.avp_no|| item?.permit_management_vehiclepermit?.avp_no || ''}</td>
                      <td style={{ width: '15%' }}>{item?.category}</td>
                      <td style={{ width: '12%', marginRight: '90px' }}>{item?.sub_category}</td>
                      <td style={{ width: '20%' }}>{item?.description}</td>
                      <td style={{ width: '10%', color: `${defectsStatus[item?.status].color}` }}>
                        {defectsStatus[item?.status].title}
                      </td>
                    </tr>
                    <hr />
                  </>
                ))}
                </tbody>
              </table>
            )}
            {violationsHistory.length===0 && defectsHistory.length === 0 && (
              <div className={styles.no_history}>
                <span>
                  No History Found
                </span>
              </div>
            )}
        </div>
      </Modal>
    </>
  );
};

export default AvpDetailPage;
